/**
 * Checks if an element is within the viewport.
 *
 * @param {Element} elem - The element to check.
 * @returns {boolean} - True if the element is in the viewport, false otherwise.
 */

export const isInViewport = (elem, offset = 0) => {
	try {
		if (!elem || !(elem instanceof Element)) {
			throw new Error('Invalid element provided');
		}
		const distance = elem.getBoundingClientRect();
		return (
			distance.top >= -offset &&
			distance.left >= 0 &&
			distance.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) +
					offset &&
			distance.right <=
				(window.innerWidth || document.documentElement.clientWidth)
		);
	} catch (error) {
		console.error('Error in isInViewport:', error);
		return false;
	}
};

/**
 * Retrieves the current Bootstrap breakpoints based on the window width.
 * @returns {Object} - An object containing the current Bootstrap breakpoints.
 */

export const getBootstrapBreakpoints = () => {
	const width = window.innerWidth;
	return {
		xs: width < 576,
		sm: width >= 576 && width < 768,
		md: width >= 768 && width < 992,
		lg: width >= 992 && width < 1200,
		xl: width >= 1200,
	};
};

export const setCookie = (cname, cvalue, exdays) => {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	const expires = `expires=${d.toUTCString()}`;
	document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

export const getCookie = (cname) => {
	const name = `${cname}=`;
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
};

export const initBanner = () => {
	const banner = document.getElementById('bannerComponent');
	const closeBanner = document.getElementById('closeBanner');
	const siteHeader = document.querySelector('.site-header');

	if (banner) {
		closeBanner.addEventListener('click', (e) => {
			e.preventDefault();
			banner.remove();
			siteHeader.style.top = '0';
			siteHeader.classList.remove('banner-visible');
			setCookie('_disban', '1', 30);
		});

		if (getCookie('_disban') !== '1') {
			banner.style.display = 'block';
			siteHeader.classList.add('banner-visible');
		}
	}
};
/**
 * Auto Slider Function
 * @param {Array} array - Array of elements to click
 * @param {Number} timeInMilliseconds - Time in milliseconds to wait before clicking the next element
 */
export const autoSlide = (array, timeInMilliseconds) => {
	if (!array || array.length === 0) return;

	let currentIndex = 0;
	let isFirstRun = true;

	setInterval(() => {
		if (currentIndex >= array.length) {
			currentIndex = 0;
			isFirstRun = false; // Reset first run after a full cycle
		}

		// Skip the first element only on the first run
		if (isFirstRun && currentIndex === 0) {
			currentIndex += 1;
		}

		// Ensure we don't go out of bounds
		if (currentIndex < array.length) {
			array[currentIndex].click();
			currentIndex += 1;
		}
	}, timeInMilliseconds);
};
